import { Injectable } from "@angular/core";
import { Observable, BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs/Subject';


@Injectable()
export class LanguageService
{
   
    public lng:string;

    private subject = new Subject<any>();

    private ngIdleMsg=new Subject<any>();

    setLng(lng: string) {
        this.subject.next(lng);
        //sessionStorage.setItem("Language",lng)

    }
    setNgIdleMsg(msg:string)
    {
        this.subject.next(msg);
    }
 
    getNgIdleMsg()
    {
        return this.ngIdleMsg.asObservable();
    }
    clearMessage() {
        this.subject.next();
    }
 
    grtLng(): Observable<string> {
        if(sessionStorage.getItem("Language")!=null)
        {
            this.lng=sessionStorage.getItem("Language");
            this.subject.next(this.lng);
        }
        return this.subject.asObservable();
    }

    setLanguage(lng)
    {
     // sessionStorage.setItem("Language",lng);
    }

    getLanguage()
    {
        if(sessionStorage.getItem("Language")!=null)
        {
            this.lng=sessionStorage.getItem("Language");
        }
        else
        {
            this.lng="en";
        }

     return this.lng;
    }

}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Services/languageService.ts